import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Loader2 } from "lucide-react";
import { ClientOption } from "@/types/staffing/serviceRequest";
import { cn } from "@/lib/utils";
import { SectionHeader, FieldRow, FieldLabel, ErrorMsg } from "./FormPrimitives";

interface ClientSectionProps {
  clients: ClientOption[];
  loadingClients: boolean;
  selectedClient: ClientOption | null;
  onClientChange: (clientId: string) => void;
  error?: string;
  disabled: boolean;
}

export function ClientSection({
  clients,
  loadingClients,
  selectedClient,
  onClientChange,
  error,
  disabled,
}: ClientSectionProps) {
  return (
    <div className="rounded-lg border border-border bg-card p-4 shadow-sm">
      <SectionHeader step={2} label="Client" />
      <FieldRow>
        <FieldLabel htmlFor="client-name" required>
          Client Name
        </FieldLabel>
        {loadingClients ? (
          <div className="flex items-center gap-2 h-10 text-sm text-muted-foreground">
            <Loader2 className="h-4 w-4 animate-spin" /> Loading clients…
          </div>
        ) : (
          <Select
            value={selectedClient ? String(selectedClient.id) : ""}
            onValueChange={onClientChange}
            disabled={disabled}
          >
            <SelectTrigger
              id="client-name"
              className={cn(error && "border-destructive")}
            >
              <SelectValue placeholder="Select a client…" />
            </SelectTrigger>
            <SelectContent>
              {clients.map((c) => (
                <SelectItem key={c.id} value={String(c.id)}>
                  {c.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        )}
        <ErrorMsg msg={error} />
      </FieldRow>
    </div>
  );
}
